// add enterprise program slug to link href if it's not an external link and program slug is provided
function buildLinkHref(href?: string | null, programSlug?: string) {
  if (!href || href.startsWith('http') || !programSlug) {
    return href ?? '';
  }

  return `/programs/${programSlug}/${href}`;
}

export default buildLinkHref;
